module.exports = __webpack_public_path__ + "static/media/LoginLogo.1fc56984.svg";